import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
// import 'moment-timezone';
import './App.css';
import gpsIcon from "./img/gps.png";
import notAllowed from "./img/exclamation-mark.png";

export default class App extends Component {

  constructor(props){
    super(props);
    this.initForm = this.initForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    const urlParams = new URLSearchParams(window.location.search);
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    this.state = {
      fields: {},
      errors: {},
      arenaId: urlParams.get('id'),
      month: urlParams.get('month'),
      year: urlParams.get('year'),
      licensePlate: urlParams.get('vehicle_no'),
      passType: urlParams.get('pass_type'),
      firstName: urlParams.get('first_name'),
      lastName: urlParams.get('last_name'),
      email: urlParams.get('email'),
      countryCode: urlParams.get('country_code'),
      contactNumber: urlParams.get('contact_number')
    };
  }

  componentDidMount(){
    const defer = () =>  {
      if (window.Stripe) {
          this.initForm(this);
      } else {
          setTimeout(function() { defer ()  }, 50);
      }
    }
    this.refreshAfterSleep();
    defer();
  }

  refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
	}

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  getMonthlyDetails(){
    let { arenaId, month, year, licensePlate, passType, firstName, lastName, countryCode, contactNumber, email } = this.state;
    if(!arenaId || !licensePlate || !passType || !countryCode || !contactNumber || !email){
      toast.error('Params missing in URL!');
      return;
    }
    fetch(`${this.baseUrl}/parking/monthly/pricing?arena_hash=${arenaId}&vehicle_no=${licensePlate ? licensePlate.toUpperCase() : ''}&month=${month}&year=${year}&pass_type=${passType}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            this.setState({ 
              isVehicleOnboarded: resp.data.vehicle_onboarded,
              parkingId: resp.data.parking_id,
              name: resp.data.parking_arena_name,
              totalFee: resp.data.rental_fee
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          toast.error('Something went wrong');
        });
  }

  
  initForm(_this){
    this.getMonthlyDetails();
    var stripe = window.Stripe(this.stripeKey);
    var elements = stripe.elements();

      var style = {
        base: {
          iconColor: '#666EE8',
          color: '#000',
          lineHeight: '40px',
          fontSize: '16px',
      
          '::placeholder': {
            color: '#000',
            fontWeight: 300,
            fontSize: '13px'
          },
        },
      };

      var card = elements.create('card', {style: style, hidePostalCode: false});

      card.mount('#card-element');

      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });

    function setOutcome(result) {
      const submitBtn = document.getElementById("pay-submit");
      if (result.source && result.source.id) {
        _this.handleSubmit(result.source.id, card);
      } else if (result.error) {
        _this.manageBodyBackground(false);
        _this.setState({loading : false});
        toast.error(result.error.message ? result.error.message : 'Something went wrong', { autoClose: 10000 });
        submitBtn.disabled = false;
      }
    }

    const validateForm = () => {
      let fields = this.state.fields;
      let formIsValid = true;
      this.errors = {};
      const cardWrapper = document.querySelector('#card-element');
      const cardWrapperError = document.querySelector('#card-errors');
      
      if(cardWrapper.classList.contains('StripeElement--empty')){
        formIsValid = false;
        cardWrapperError.innerHTML = "enter your card number";
      }
      if(cardWrapper.classList.contains('StripeElement--invalid')){
        formIsValid = false;
        if(!cardWrapperError.innerHTML.trim()) cardWrapperError.innerHTML = "enter valid details";
      }
      if (!fields["cardholder_name"] || (fields["cardholder_name"] && fields["cardholder_name"].trim() === '')) {
        formIsValid = false;
        this.errors["cardholder_name"] = "enter the cardholder name";
      }
      this.setState({
        errors: this.errors
      });
      return formIsValid;
    }

    document.querySelector('form').addEventListener('submit', function(e) {
      e.preventDefault();
      document.getElementById("pay-submit").disabled =  true;
      if(_this.state.loading) return;
      const submitBtn = document.getElementById("pay-submit");
      const isValid = validateForm();
      if(!isValid) {
        submitBtn.disabled = false;
        return;
      }
      if(!_this.state.totalFee){
        toast.error('Invalid details!');
        submitBtn.disabled = false;
        return;
      }
      _this.manageBodyBackground(true);
      _this.setState({loading : true});
      let fields  = _this.state; 
      var options = {
        statement_descriptor: 'Monthly parking at ' + fields.name,
        owner: {
          name: _this.state.fields.cardholder_name,
          email: fields.email,
          phone: "+" + fields.countryCode + ' ' + fields.contactNumber
        }
      };
      stripe.createSource(card, options).then(setOutcome, _this);
    });
  }

  handleSubmit(id, card){
    const submitBtn = document.getElementById("pay-submit");
    let { month, year, licensePlate, passType, parkingId } = this.state;
    const request = {
      source_id: id,
      parking_id: parkingId,
      vehicle_no: licensePlate ? licensePlate.toUpperCase().trim() : '',
      month: month ? month.toLowerCase() : '',
      year: year ? parseInt(year) : 0,
      pass_type: passType
    }
    toast.error('API not found');
    return;
    fetch(`${this.baseUrl}/payment/parking/monthly`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          window.scrollTo(0,0);
          this.setState({booked: true, loading: false}, () => {
            card.clear();
            /* this.getMonthlyDetails();
            submitBtn.disabled = false; */
          });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          this.manageBodyBackground(false);
          this.setState({loading : false});
          toast.error(errMsg, { autoClose: errMsg.length > 20 ? 10000 : 2000 });
          submitBtn.disabled = false;
        }
      })
      .catch((error) => {
        this.manageBodyBackground(false);
        this.setState({loading : false});
        toast.error('Something went wrong');
        submitBtn.disabled = false;
      });  
  }

  handleClose(){
    this.setState({booked: false, bookedID: null }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleChange(e) {
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value;
    this.setState({
        fields
      });
  }


  render() {
    return (
      <div style={{position: 'relative'}}>
        {this.state.isVehicleOnboarded === false &&  <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10, backgroundColor: 'rgba(255, 255, 255, 0.90)'}}></div>}
        {this.state.loading &&  <div style={{position: 'absolute', width: '100%', height: '100%', zIndex: 10}}></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        <div style={{display: this.state.isVehicleOnboarded === false ? 'block' : 'none'}} className="success-message">
          <div style={{textAlign: 'center'}}>
            <img style={{height: 55}} src={notAllowed} /> 
          </div>
          <h3 style={{color: '#000'}} className="success-message__title">Not registered for monthly parking</h3>
        </div>
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          {/* <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span> */}
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Payment Successfull</h3>
          {/* <div className="success-message__content">
              <p>Booking Id: {this.state.bookingID}</p>
          </div> */}
        </div>
        <form style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto'}} action="#" method="POST">
          <input type="hidden" name="token" />
          <div style={{textAlign: 'center', paddingBottom: 20}}>
            <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
          </div>
          <div>
            <h2 style={{textAlign: 'center', fontSize: '22px'}}>Update Payment Details</h2>
          </div>
          <div style={{textAlign: 'center', padding: '30px 0'}} className="location">
            <img style={{height: 35}} src={gpsIcon} /> 
            <span>{this.state.name}</span>
          </div>

          <ul className="pay-timings">
            <li>
              <span className="list-initial">License Plate No.</span>
              <span style={{textTransform: 'uppercase'}}>{this.state.licensePlate}</span>
            </li>
            <li>
              <span className="list-initial">Pass Type</span>
              <span style={{textTransform: 'capitalize'}}>{this.state.passType}</span>
            </li>
          </ul>
          <h5 style={{padding: "15px 0"}}>Card Information</h5>
          <div className="card-info">
            <div id="card-element">
            </div>
          </div>
          <div className="error-msg" id="card-errors" role="alert"></div>
          <div class="group">
            <label>
              <input onChange={this.handleChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder name" />
            </label>
          </div>
          <div style={{padding: '6px 0 0 14px'}} className="error-msg">{this.state.errors['cardholder_name']}</div>
          <button style={{marginBottom: '60px'}} id="pay-submit" type="submit">Save</button>
          <div style={{clear: 'both'}} />
          
          <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
        </form>
      </div>      
    )
  }
}
